module.exports = __webpack_public_path__ + "media/images/google-play-btn-8334ad89f33a480d1615e106347e2615.svg";